import React, { Fragment } from "react";
import { useHistory } from "react-router-dom";
import { Badge, Icon } from "@culturehq/components";
import * as CHQ from "chq";

import { getInterestPath, getSkillPath } from "app/links";

import LazyEditorOutput from "components/editor/LazyEditorOutput";

import styles from "./styles.module.scss";

type EndorsementUserInterestProps = {
  userInterest: CHQ.UserInterest;
};

const EndorsementUserInterest: React.FC<EndorsementUserInterestProps> = ({ userInterest }) => {
  const history = useHistory();
  const onClick = () => history.push(getInterestPath(userInterest.interest));

  return (
    <Badge onClick={onClick} primary>
      <Icon icon="heart-ol" />
      {userInterest.interest.name}
    </Badge>
  );
};

type EndorsementUserSkillProps = {
  userSkill: CHQ.UserSkill;
};

const EndorsementUserSkill: React.FC<EndorsementUserSkillProps> = ({ userSkill }) => {
  const history = useHistory();
  const onClick = () => history.push(getSkillPath(userSkill.skill));

  return (
    <Badge onClick={onClick} icon="hammer" primary>
      {userSkill.skill.name}
    </Badge>
  );
};

type EndorsementBodyProps = {
  endorsement: CHQ.Endorsement;
};

const EndorsementBody: React.FC<EndorsementBodyProps> = ({ endorsement }) => (
  <>
    <div className={styles.output}>
      <LazyEditorOutput output={endorsement.body} />
    </div>
    <div className={styles.tags}>
      {endorsement.userInterests.map(userInterest => (
        <Fragment key={userInterest.id}>
          <EndorsementUserInterest userInterest={userInterest} />
          {" "}
        </Fragment>
      ))}
      {endorsement.userSkills.map(userSkill => (
        <Fragment key={userSkill.id}>
          <EndorsementUserSkill userSkill={userSkill} />
          {" "}
        </Fragment>
      ))}
    </div>
  </>
);

export default EndorsementBody;
